// extracted by mini-css-extract-plugin
export default {"searchParent":"search_searchParent__zc3xl","search":"search_search__TTITV","svgMagnifier":"search_svgMagnifier__Suk0v"};